module.exports = __webpack_public_path__ + "ab053a94779dcaf3b2f4e1bda2ccbcc2.pdf";